import { useEffect, useState } from "react";
import Counter from "../component/Counter";
import { Link } from "react-scroll";
import EnquiryPopup from "../component/EnquiryPopup";

const Home = () => {
  const heading = [
    "Tech Solutions",
    "End-to-End Solutions",
    "Digital Solutions",
    "Smart Tech Solutions",
  ];

  const [currentIndex, setCurrentIndex] = useState(0);
  const [animate, setAnimate] = useState(true);
  const [enquiryOpen, setEnquiryOpen] = useState(false);

  useEffect(() => {
    const interval = setInterval(() => {
      setAnimate(false);

      setTimeout(() => {
        setCurrentIndex((prev) => (prev + 1) % heading.length);
        setAnimate(true);
      }, 400);
    }, 2500);

    return () => clearInterval(interval);
  }, []);

  return (
    <div className=" px-4 md:mt-[5%]  md:px-20 justify-center flex flex-col items-center relative  h-screen">
      <div className="absolute inset-0 -z-10">
        <img
          src="/assets/background.svg"
          alt="Background"
          className="w-full h-full object-cover"
        />
      </div>
      <h1 className="text-[30px] md:text-[78px] font-normal font-clash leading-10 md:leading-none text-nowrap text-black mt-10 md:mt-[20%]">
        Transforming ideas{" "}
        <span className="font-thin text-[#0A0A0A]">into</span>
      </h1>
      <h1 className="text-[20px] md:text-[72px] font-medium font-clash leading-10 md:leading-none text-nowrap">
        Impactful{" "}
        <span className="inline-block h-[40px] md:h-[90px] overflow-hidden align-middle">
          <span
            className={`
            inline-block
            transition-all duration-700 ease-out
            ${animate ? "opacity-100 translate-y-0" : "opacity-0 translate-y-2"}
            text-[20px] md:text-[72px]
            bg-gradient-to-r from-[#FE4A33] to-[#FEAEA4]
            bg-clip-text text-transparent
            font-clash font-medium
          `}
          >
            {heading[currentIndex]}
          </span>
        </span>
        <br />
        <div className="text-center font-medium font-clash text-[20px] md:text-[72px]">
          Worldwide.
        </div>
      </h1>

      <div className="flex-row mt-[10%] md:mt-[5%]  md:flex   gap-10">
        {[
          {
            number: "10+",
            label: "Years of Excellence",
            icon: "/assets/star.svg",
          },
          {
            number: "92%",
            label: "Success Rate",
            icon: "/assets/Flame.svg",
          },
          {
            number: "100+",
            label: "Thriving Projects",
            icon: "/assets/Vector.svg",
          },
        ].map((item, index) => (
          <div
            key={index}
            className="w-[168px] h-[77px] bg-[#FFF7F7] rounded-2xl relative
             flex items-center p-[6px] gap-[10px]"
          >
            <div className=" bg-gradient-to-r from-[#FF1E00] to-[#FFF7F7] p-[1px] rounded-2xl ">
              <div
                className="w-[65px] h-[65px] flex items-center justify-center  
                 text-[20px] font-clash font-semibold
                 background: linear-gradient(304.14deg, rgba(251, 30, 1, 0) 10.15%, #FF1E00 120.03%);
                 rounded-2xl text-black text-center"
              >
                <Counter
                  target={parseInt(item.number)}
                  suffix={item.number.replace(/\d/g, "")}
                  duration={8000}
                />
              </div>
            </div>

            <p className="text-[10px] md:text-[16px] font-clash font-normal leading-tight text-black">
              {item.label}
            </p>

            <div className="absolute -right-3 -top-2 w-[24px] h-[24px]">
              <img src={item.icon} alt="icon" className="w-full h-auto" />
            </div>
          </div>
        ))}
      </div>

      <div className="mt-[20%] md:mt-[5%] flex justify-center items-center relative mb-[20%]">
        <div className="absolute w-[260px] h-[70px] rounded-2xl bg-primary/40 blur-2xl"></div>

       
          <button
            onClick={() => setEnquiryOpen(!enquiryOpen)}
            className="
      relative z-10
      bg-primary
      text-[16px]
      px-10 py-4
      rounded-2xl
      text-white
      font-clash font-semibold
      tracking-wide
      transition-transform duration-300
      hover:scale-105
    "
          >
            LET’S TALK
          </button>
      
      </div>
      {enquiryOpen && <EnquiryPopup onClose={() => setEnquiryOpen(false)} />}
    </div>
  );
};

export default Home;
